import Enumerator from '../global/Enumerator';

export const riskInsuranceProductTypes = [
  'private_health',
  'tpd_provider',
  'life_provider',
  'income_protection',
  'trauma'
];

export class RiskInsuranceProductType extends Enumerator {
  static default() {
    return this.of('private_health');
  }
}

RiskInsuranceProductType.initEnum({
  private_health: {
    get title() {
      return 'Private health';
    },
    get weight() {
      return 1;
    }
  },
  tpd_provider: {
    get title() {
      return 'TPD provider';
    },
    get weight() {
      return 2;
    }
  },
  life_provider: {
    get title() {
      return 'Life provider';
    },
    get weight() {
      return 3;
    }
  },
  income_protection: {
    get title() {
      return 'Income protection';
    },
    get weight() {
      return 4;
    }
  },
  trauma: {
    get title() {
      return 'Trauma';
    },
    get weight() {
      return 5;
    }
  }
});

export default {
  riskInsuranceProductTypes,
  RiskInsuranceProductType
};
